module.exports = "/work-site/img/exit_pic.1f0fb909.png";